// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3gAhc","header":"MergedInvoice_header__1E3gK"};